import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoFavorito } from "../../../types/documento/favorito/DocumentoFavorito";
import { DocumentoFavoritoDTO } from "../../../types/documento/favorito/DocumentoFavoritoDTO";
import { DocumentoFavoritoList } from "../../../types/documento/favorito/DocumentoFavoritoList";

const endpointUrl = configUrls.DOCUMENTO_FAVORITO_EP;

type Search = {
    id: string;
    search: string;
};



function getDocumentosFavoritos({ id, search }: Search) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/favoritos/${id}?search=${search}`,
        method: "GET",
    }
}

function getDocumentoFavorito(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/favorito/${id}`,
        method: "GET",
    }
}

function getDocumentoFavoritoExists(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/favorito/exists/${id}`,
        method: "GET",
    }
}


function deleteFavoritoDocumento(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/favorito/${id}`,
        method: "DELETE",
    }
}


function darFavoritoDocumento(data: DocumentoFavoritoDTO) {
    return {
        url: `${endpointUrl}/favorito`,
        method: "POST",
        body: data,
    }
}

export const documentoFavoritoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getDocumentosFavoritos: query<DocumentoFavoritoList[], { id: string, search: string }>({
            query: getDocumentosFavoritos,
            providesTags: ["Documento"],
        }),

        getDocumentoFavorito: query<DocumentoFavorito, string>({
            query: getDocumentoFavorito,
            providesTags: ["Documento"],
        }),

        getDocumentoFavoritoExists: query<boolean, string>({
            query: getDocumentoFavoritoExists,
            providesTags: ["Documento"],
        }),

        createFavoritoDocumento: mutation<void, DocumentoFavoritoDTO>({
            query: darFavoritoDocumento,
            invalidatesTags: ["Documento"],
        }),
        deleteFavoritoDocumento: mutation<void, string>({
            query: deleteFavoritoDocumento,
            invalidatesTags: ["Documento"],
        }),

    }),
});

export const {
    useGetDocumentosFavoritosQuery,
    useCreateFavoritoDocumentoMutation,
    useDeleteFavoritoDocumentoMutation,
    useGetDocumentoFavoritoQuery
} = documentoFavoritoApiSlice